<script setup lang="ts">
import { computed } from 'vue';
import { DEMO_URL } from '@Constants';

withDefaults(
  defineProps<{
    hasSlogan?: boolean;
  }>(),
  {
    hasSlogan: true,
  }
);

const isDemo = computed(() => window.location.hostname.includes(DEMO_URL));
</script>

<template>
  <div class="relative sm:mx-auto sm:w-full sm:max-w-sm">
    <Tag
      v-if="isDemo"
      class="mx-auto mb-2 flex h-7 w-[53px] cursor-default text-sm"
      severity="danger"
      :value="$t('common.demo')"
    />

    <ALogo />

    <!-- TODO : [AF-182] Double check if and how to i18n this -->
    <h1
      v-if="hasSlogan"
      class="mt-3 text-center text-lg font-normal tracking-tight text-gray-500 sm:text-2xl"
    >
      Shelter & Rescue <br />Management Software
    </h1>
  </div>
</template>
